import { render, staticRenderFns } from "./LocalCategorySelect.vue?vue&type=template&id=2133f68d&"
import script from "./LocalCategorySelect.vue?vue&type=script&lang=js&"
export * from "./LocalCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports